const deviceType = () => {
  const mobileMediaQuery = matchMedia('screen and (min-width: 0px) and (max-width: 1023px)');
  return mobileMediaQuery.matches ? 'mobile' : 'desktop';
};

export const isDesktop = () => deviceType() === 'desktop';

export default deviceType;
